import { Link } from "react-router-dom";
import { Logomark } from "@/components/Logomark";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-[hsl(222_47%_7%)] text-slate-300">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <Logomark className="h-12 w-12 shrink-0" />
              <div className="font-display text-2xl font-bold tracking-tight text-white">BIGTEK</div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              BIGTEK is the technology arm of Bigibila. We build governance-first technology for
              government, enterprise, Nations and community-controlled organisations — grounded in
              data sovereignty, verified authority and evidence.
            </p>
            <p className="mt-6 text-xs leading-relaxed text-slate-500">
              Website: bigtek.com.au &middot; Enquiries: bigtek@bigibila.com.au &middot;
              Consultancy: bigibila.com.au
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest-xs text-slate-500">Catalogue</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/catalogue" className="text-slate-400 hover:text-white">All products</Link></li>
              <li><Link to="/governance-model" className="text-slate-400 hover:text-white">Governance model</Link></li>
              <li><Link to="/pricing-rules" className="text-slate-400 hover:text-white">Pricing & licensing</Link></li>
              <li><Link to="/readiness-check" className="text-slate-400 hover:text-white">Readiness Self-Check</Link></li>
              <li><Link to="/data-handling" className="text-slate-400 hover:text-white">Data handling</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest-xs text-slate-500">Legal</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/data-handling" className="text-slate-400 hover:text-white">Privacy & consent</Link></li>
              <li><Link to="/admin/login" className="text-slate-400 hover:text-white">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-slate-800 pt-8">
          <p className="text-xs leading-relaxed text-slate-500">
            All pricing is <strong className="text-slate-400">indicative, subject to scope and excludes GST</strong>.
            Content on this site is not legal advice and does not constitute cultural certification or
            accreditation. Trade marks (™) are used as claimed; entity and IP status are subject to
            confirmation. Nation authority and project-specific cultural permissions must be independently
            validated. &copy; {new Date().getFullYear()} BIGTEK.
          </p>
        </div>
      </div>
    </footer>
  );
}
